import React from 'react'
import { ISection, Language, ITheme } from '@/lib/interfaces/interfaces'
import { NextFont } from 'next/dist/compiled/@next/font'
import GoogleGIcon from '../widgets/my-menu/GoogleGIcon'
import Stars from './GoogleReviewStars'
import { GOOGLE_REVIEW_COPY } from '@/lib/utils/googleReview'
import '../../sass/menu/ModernGoogleReviewBlock.scss'

interface ModernGoogleReviewBlockProps {
  section: ISection
  theme: ITheme
  language: Language
  fontStyle: {
    fontFamily: NextFont
    fontSize: string
  }
}

const ModernGoogleReviewBlock: React.FC<ModernGoogleReviewBlockProps> = ({ section, theme, language, fontStyle }) => {
  const url = section.googleReview?.url?.trim() || ''
  if (!url) return null

  const copy = GOOGLE_REVIEW_COPY[language] || GOOGLE_REVIEW_COPY.es

  return (
    <div className='modern-section modern-google-review-section'>
      <div className='modern-items-grid'>
        <div className='modern-item-wrapper modern-google-review-wrapper' style={{ '--animation-index': 0 } as React.CSSProperties}>
          <div className='modern-google-review-card' style={{ background: theme.sectionBgColor }}>
            <div className='modern-google-review__row1'>
              <div className='modern-google-review__badge'>
                <span className='modern-google-review__gicon'><GoogleGIcon size={16} /></span>
                <span className='modern-google-review__brandtext'>Google</span>
              </div>
              <Stars />
            </div>

            <div className='modern-google-review__row2'>
              <div className='modern-google-review-text'>
                <h3
                  className='modern-google-review-title'
                  style={{
                    color: theme.items.nameColor,
                    ...fontStyle.fontFamily.style,
                    fontSize: fontStyle.fontSize
                  }}
                >
                  {copy.title}
                </h3>
                <p
                  className='modern-google-review-description'
                  style={{
                    color: theme.items.descriptionColor,
                    ...fontStyle.fontFamily.style,
                    fontSize: `calc(${fontStyle.fontSize} - 0.15rem)`
                  }}
                >
                  {copy.description}
                </p>
              </div>
              <a
                className='modern-google-review-button'
                href={url}
                target='_blank'
                rel='noopener noreferrer'
              >
                {copy.button}
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default ModernGoogleReviewBlock
